import { render } from "./PDFOrcamentoFinal.vue?vue&type=template&id=f099ca4e&scoped=true"
import script from "./PDFOrcamentoFinal.vue?vue&type=script&lang=js"
export * from "./PDFOrcamentoFinal.vue?vue&type=script&lang=js"

import "./PDFOrcamentoFinal.vue?vue&type=style&index=0&id=f099ca4e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f099ca4e"]])

export default __exports__